import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Row, Button, Container } from 'reactstrap';
import { Tile } from './Tile';

const ProductTilesComponent = ({ tiles, history, navigateToShop }) => (
  <>
    <hr id="product-types" />
    <section className="products-section">
      <Container>
        <h1 className="text-center mb-5">Shop by type</h1>
        <Row className="d-flex justify-content-center">
          {tiles.map(tile => (
            <Tile key={tile.name} tile={tile} history={history} />
          ))}
        </Row>
        <Row className="mt-5 justify-content-center">
          <Button
            color="primary"
            size="lg"
            className="shop-all-button"
            onClick={() => navigateToShop({ position: 'vendor-shop-all' })}
          >
            Shop All
          </Button>
        </Row>
      </Container>
    </section>
  </>
);

ProductTilesComponent.propTypes = {
  tiles: PropTypes.array,
  history: PropTypes.object.isRequired,
  navigateToShop: PropTypes.func.isRequired,
};

export const ProductTilesSection = memo(ProductTilesComponent);
